module.exports = __webpack_public_path__ + "media/images/shared/ad/maretu01-c7c94628a7630ebcdd52c6ffdf74ac22.png";